/**
 * Algolia click attribution reaches the PDP via a `qid` query param
 * (read by cart-functions.ts and ecommerce-analytics.ts). Rendering that
 * param directly in hrefs let Google index `?qid=` duplicates of product
 * URLs, so links now render clean with the queryID in `data-qid` and the
 * param is attached only when a real user activates the link.
 */

const attachQid = (event: Event) => {
  const target = event.target as Element | null;
  const link = target?.closest?.('a[data-qid]') as HTMLAnchorElement | null;

  if (!link?.dataset.qid) {
    return;
  }

  const url = new URL(link.href, window.location.origin);
  url.searchParams.set('qid', link.dataset.qid);
  link.href = url.toString();
};

let enabled = false;

/**
 * Rewrite `a[data-qid]` links to include their queryID at activation time.
 * Document-level delegation, so it covers re-rendered InstantSearch hits and
 * the autocomplete panel alike. Safe to call from multiple modules.
 */
export const enableQidLinks = () => {
  if (enabled) {
    return;
  }
  enabled = true;

  // pointerdown fires before navigation for any mouse button and for touch;
  // keydown covers Enter on a focused link.
  document.addEventListener('pointerdown', attachQid);
  document.addEventListener('keydown', attachQid);
};
